/* eslint-disable no-restricted-imports */
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

export const PRODUCT_BEFORE_PAYMENT_ATTRIBUTE = 'product_before_payment';

export const PRODUCT_BEFORE_PAYMENT_QUERY_KEY = 'productBeforePayment';

export const PRODUCT_BEFORE_PAYMENT_FALLBACK = 'true';

const normalizeProductBeforePaymentId = (id: unknown): string | undefined => {
	if (valueIsString(id) && id.trim()) {
		return id.trim();
	}

	if (typeof id === 'number' && !isNaN(id)) {
		return String(id);
	}

	return undefined;
};

export const getProductBeforePaymentValue = (id: unknown) =>
	normalizeProductBeforePaymentId(id) ?? PRODUCT_BEFORE_PAYMENT_FALLBACK;

/**
 * Lee el id del espot desde el query del router. Devuelve undefined cuando el param no viene, para
 * que un add to cart normal del PDP no envie el atributo.
 */
export const getProductBeforePaymentFromQuery = (query: unknown): string | undefined => {
	const raw = getValueByPathFromUnknown(query, [PRODUCT_BEFORE_PAYMENT_QUERY_KEY]);
	return normalizeProductBeforePaymentId(Array.isArray(raw) ? raw[0] : raw);
};
